import api from "@/lib/api";

export const formatBytes = (n) => {
  if (!n) return "0 B";
  const u = ["B", "KB", "MB", "GB"];
  const i = Math.min(u.length - 1, Math.floor(Math.log(n) / Math.log(1024)));
  return `${(n / 1024 ** i).toFixed(i ? 1 : 0)} ${u[i]}`;
};

// Chunked upload with per-chunk retry (resumes on flaky connections).
export async function uploadInChunks(bootcamp, file, { note = "", taskId = null, onProgress } = {}) {
  const { data: init } = await api.post(`/bootcamps/${bootcamp}/uploads/init`, {
    filename: file.name,
    size: file.size,
    content_type: file.type || "application/octet-stream",
    note,
    task_id: taskId,
  });
  const { upload_id, chunk_size, total_chunks } = init;
  for (let i = 0; i < total_chunks; i++) {
    const blob = file.slice(i * chunk_size, Math.min(file.size, (i + 1) * chunk_size));
    let attempt = 0;
    for (;;) {
      try {
        await api.put(`/bootcamps/${bootcamp}/uploads/${upload_id}/chunk/${i}`, blob, {
          headers: { "Content-Type": "application/octet-stream" },
          timeout: 120000,
        });
        break;
      } catch (e) {
        if (++attempt >= 4 || (e.response && e.response.status < 500 && e.response.status !== 408)) throw e;
        await new Promise((r) => setTimeout(r, 1000 * attempt));
      }
    }
    onProgress?.(Math.round(((i + 1) / total_chunks) * 100));
  }
  const { data } = await api.post(`/bootcamps/${bootcamp}/uploads/${upload_id}/complete`, {}, { timeout: 300000 });
  return data.submission;
}

export async function downloadBlob(url, filename) {
  const res = await api.get(url, { responseType: "blob", timeout: 600000 });
  const href = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(href), 30000);
}

export const STATUS_LABEL = { not_started: "Not started", submitted: "Work submitted", completed: "Completed" };
export const STATUS_CHIP = { not_started: "chip chip-muted", submitted: "chip chip-amber", completed: "chip chip-success" };
